import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api, adminCall, fmt, formatApiError } from "../../api";

export default function OrdersPanel() {
  const [orders, setOrders] = useState(null);

  const load = () =>
    adminCall(() => api.get("/admin/orders"))
      .then((r) => setOrders(r.data.orders))
      .catch((e) => toast.error(formatApiError(e)));

  useEffect(() => {
    load();
  }, []);

  const resend = async (o) => {
    try {
      await adminCall(() => api.post(`/admin/orders/${o.id}/resend`));
      toast.success(`Receipt re-sent to ${o.buyer_email}`);
    } catch (e) {
      toast.error(formatApiError(e, "Could not re-send the receipt."));
    }
  };

  return (
    <div data-testid="admin-orders-panel">
      <h2 className="font-serif text-2xl text-ink">Orders</h2>
      <p className="mt-1 text-sm text-ink/50">
        Only orders with verified Stripe payment appear here — each was fulfilled automatically.
      </p>
      <div className="mt-6 overflow-x-auto rounded-2xl border border-sage/12 bg-white/80" data-testid="admin-orders-list">
        <table className="w-full min-w-[680px] text-left text-sm">
          <thead>
            <tr className="border-b border-sage/10 font-mono text-[10px] uppercase tracking-[0.2em] text-ink/45">
              <th className="px-5 py-4">Date</th>
              <th className="px-5 py-4">Product</th>
              <th className="px-5 py-4">Customer</th>
              <th className="px-5 py-4">Amount</th>
              <th className="px-5 py-4">Promo</th>
              <th className="px-5 py-4">Downloads</th>
              <th className="px-5 py-4"></th>
            </tr>
          </thead>
          <tbody>
            {(orders || []).map((o) => (
              <tr key={o.id} className="border-b border-sage/5 last:border-0" data-testid={`order-row-${o.id.slice(0, 8)}`}>
                <td className="px-5 py-4 text-ink/60">{new Date(o.created_at).toLocaleDateString()}</td>
                <td className="px-5 py-4 font-medium text-ink">{o.product_name}</td>
                <td className="px-5 py-4 text-ink/60">{o.buyer_email || "—"}</td>
                <td className="px-5 py-4 font-mono text-xs text-sage-deep">{fmt(o.amount, o.currency)}</td>
                <td className="px-5 py-4">
                  {o.promo_code ? (
                    <span className="rounded-full bg-lavender-tint px-3 py-1 font-mono text-[11px] tracking-wider text-lavender-deep">{o.promo_code}</span>
                  ) : (
                    <span className="text-ink/30">—</span>
                  )}
                </td>
                <td className="px-5 py-4 text-ink/60">{o.downloads}</td>
                <td className="px-5 py-4 text-right">
                  <button onClick={() => resend(o)} data-testid={`resend-receipt-${o.id.slice(0, 8)}`}
                    className="inline-flex items-center gap-1.5 rounded-full border border-sage/20 px-3.5 py-1.5 text-[11px] text-sage transition-colors hover:bg-sage hover:text-cream">
                    <Mail size={12} /> Re-send receipt
                  </button>
                </td>
              </tr>
            ))}
            {orders && orders.length === 0 && (
              <tr><td colSpan={6} className="px-5 py-10 text-center text-ink/45">No orders yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
